import { dashboard } from 'types';
import GuestAndVisitIcons from 'components/crm/GuestAndVisitIcons';

interface Props {
  waitlistRequest: dashboard.CalendarWaitlist;
}

export const WaitlistIcons: React.FC<Props> = ({ waitlistRequest }) => {
  const hasNote = waitlistRequest?.note ? true : false;

  return (
    <GuestAndVisitIcons
      guestProfile={waitlistRequest.guestProfile as dashboard.GuestProfile}
      visitTags={[]}
      hasQuickNote={hasNote}
      hasVisitNote={!!waitlistRequest?.guestNote}
      hasVisitDietaryNote={false}
      hasPaymentRequired={false}
      hasNewMessage={false}
      hasAnsweredQuestion={false}
      hasPurchasedSupplements={false}
      noParentWrapper
      renderDot
      isPartyCard
    />
  );
};
